import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setOrganizations, fetchOrganizations } from '../../store/features/organizationSlice';
import AtomicSpinner from 'atomic-spinner';
import { Button } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import OrganizationView from './organizationView';
import styles from './organization.module.scss';
import Pagination from '../../models/Pagination';
import TableControl from '../../component/_shared/table/tableControl';
import WithAuth from '../../component/_HighOrder/withAuth';
import WithNotify from '../../component/_HighOrder/withNotify';

const Organization = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [openFilter, setOpenFilter] = useState(false);
    const [pagination, setPagination] = useState({ ...(new Pagination(1, 10, '', 'ASC')) });
    const [organization, setOrganization] = useState(null);
    const [filter, setFilter] = useState({
        active: true,
        address: '',
        'address_postalcode': '',
        name: ''
    });
    const organizations = useSelector((state) => state.organization.organizations);

    useEffect(() => {
        getOrganizations();
    }, [pagination?.pageIndex, pagination?.pageSize, pagination?.sortCol, pagination?.sortType]);

    const getOrganizations = () => {
        setLoading(true);

        var tokenData = props.getValidProviderDirectoryToken({
            callback: (tokenData) => {
                dispatch(fetchOrganizations({
                    filter,
                    pagination,
                    token: tokenData.access_token,
                    callback: (response) => {
                        dispatch(setOrganizations(response.Data));
                        setPagination(new Pagination().set(pagination).setCount(response.Rows))
                        setLoading(false);
                    },
                    catch: (error) => {
                        setLoading(false);
                        dispatch(setOrganizations([]));
                        props.notify.error(error.message);
                    }
                }))
            },
            catch: (error) => {
                setLoading(false);
                dispatch(setOrganizations([]));
                props.notify.error(error.message);
            }
        });
    };

    const clearFilter = () => {
        setFilter({
            active: true,
            address: '',
            'address_postalcode': '',
            name: ''
        });
    };

    const getFilter = () => {
        if (!openFilter)
            return <></>;

        return (
            <div className={styles.filterDiv}>
                <div className={styles.filterItem}>
                    <p>Active</p>
                    <select value={filter.active} onChange={(event) => setFilter({ ...filter, active: event.target.value })} style={{ fontSize: 12, height: 20 }}>
                        <option value={''}></option>;
                        <option value={true}>Active</option>
                        <option value={false}>Inactive</option>
                    </select>
                </div>
                <div className={styles.filterItem}>
                    <p>Name</p>
                    <input type='text' value={filter.name} onChange={(event) => setFilter({ ...filter, name: event.target.value })}></input>
                </div>
                <div className={styles.filterItem}>
                    <p>Address</p>
                    <input type='text' value={filter.address} onChange={(event) => setFilter({ ...filter, address: event.target.value })}></input>
                </div>
                <div className={styles.filterItem}>
                    <p>Postal Code</p>
                    <input type='text' value={filter['address_postalcode']} onChange={(event) => setFilter({ ...filter, 'address_postalcode': event.target.value })}></input>
                </div>
                <div className={styles.filterItem}>
                    <Button onClick={getOrganizations}>
                        Search
                    </Button>
                    <Button onClick={clearFilter}>
                        Clear
                    </Button>
                </div>
            </div>
        )
    };

    const viewDetails = (id) => {
        setOrganization(organizations.entry.filter((item) => item.resource.id.value === id)[0]);
    };

    const mountRows = () => {
        return organizations.entry.map((item, index) => {
            return <tr key={index} className={(index % 2) > 0 ? styles.oddLine : styles.evenLine}>
                <td className={styles.tableColumn}>
                    <p>{item.resource.id.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.name.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.alias && item.resource.alias?.length > 0 ? item.resource.alias.map(item => item.value).join(', ') : ''}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.contact && item.resource.contact?.length > 0 ? item.resource.contact?.map((item) => item.name.text.value).join(', ') : ''}</p>
                </td>
                <td className={styles.tableColumn}>
                    <Button onClick={() => viewDetails(item.resource.id.value)}>
                        <MenuOpenIcon />
                    </Button>
                </td>
            </tr>
        });
    };

    const getList = () => {
        if (organization)
            return <></>;

        return (
            loading ? <div className={styles.atomicSpiner}><AtomicSpinner /></div>
                :
                <Fragment>
                    <Button color='primary' onClick={() => setOpenFilter(!openFilter)}>
                        <FilterListIcon />
                        Filter
                    </Button>
                    {getFilter()}
                    <br />
                    <br />
                    <table className={styles.organizationTable}>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Name</th>
                                <th>Alias</th>
                                <th>Contact</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                organizations && organizations.entry?.length > 0 ?
                                    mountRows()
                                    :
                                    <tr>
                                        <td colSpan='3'>
                                            <p>No Results</p>
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                    {organizations && organizations.entry?.length > 0 ? <TableControl pagination={pagination} setPagination={setPagination} /> : <></>}
                </Fragment>
        );
    };

    const getView = () => {
        if (organization)
            return (
                <div>
                    <button className={styles.filterBtn} onClick={getBack}>Back</button>
                    <OrganizationView organization={organization}></OrganizationView>
                </div>
            );

        return <></>;
    };

    const getBack = () => {
        setOrganization(null);
    };

    return (
        <div className={styles.organizationDiv}>
            <h2>Organization Page</h2>

            {getView()}

            {getList()}
        </div>
    );
};

export default WithNotify(WithAuth(Organization));